export default "__VITE_ASSET__BxOa5jbT__"